import React from 'react';
import style from './style.module.scss';

interface StatRow {
    label: string;
    value: string | number;
}

interface LabattStatCardProps {
    icon: React.ReactNode;
    title: string;
    stats: StatRow[];
}

// Card for displaying a stat with icon, title, and up to three stat rows
const LabattStatCard: React.FC<LabattStatCardProps> = ({
    icon,
    title,
    stats,
}) => (
    <div className={style.labatt_stat_card}>
        <div className={style.labatt_stat_icon}>{icon}</div>
        <div className={style.labatt_stat_title}>{title}</div>
        <div className={style.labatt_stat_rows} data-stat-count={stats.length}>
            {stats.map((row, idx) => (
                <div className={style.labatt_stat_row} key={idx}>
                    <span className={style.labatt_stat_label}>{row.label}</span>
                    <span className={style.labatt_stat_value}>{row.value}</span>
                </div>
            ))}
        </div>
    </div>
);

export default LabattStatCard;
